import { START, SUCCESS, ERROR } from '../../../../constants/action-postfix'
import {
  COMMISSION_LIST_REQUEST,
  COMMISSION_GET_REQUEST,
  COMMISSION_CREATE_REQUEST,
  COMMISSION_UPDATE_REQUEST,
  COMMISSION_DELETE_REQUEST,
  COMMISSION_MEMBERS_REQUEST,
  COMMISSION_MEMBER_ADD_REQUEST,
  COMMISSION_MEMBER_DELETE_REQUEST,
} from '../commissionActionTypes'

const START_ACTIONS = [
  COMMISSION_LIST_REQUEST,
  COMMISSION_GET_REQUEST,
  COMMISSION_CREATE_REQUEST,
  COMMISSION_UPDATE_REQUEST,
  COMMISSION_DELETE_REQUEST,
  COMMISSION_MEMBERS_REQUEST,
  COMMISSION_MEMBER_ADD_REQUEST,
  COMMISSION_MEMBER_DELETE_REQUEST,
].map(type => `${type}${START}`)

const DONE_ACTIONS = [
  COMMISSION_LIST_REQUEST,
  COMMISSION_GET_REQUEST,
  COMMISSION_CREATE_REQUEST,
  COMMISSION_UPDATE_REQUEST,
  COMMISSION_DELETE_REQUEST,
  COMMISSION_MEMBERS_REQUEST,
  COMMISSION_MEMBER_ADD_REQUEST,
  COMMISSION_MEMBER_DELETE_REQUEST,
].flatMap(type => [`${type}${SUCCESS}`, `${type}${ERROR}`])

const initialState = false

export const commissionLoaderReducer = (state = initialState, action) => {
  if (START_ACTIONS.includes(action.type)) return true
  if (DONE_ACTIONS.includes(action.type))  return false
  return state
}
